import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import EditTaskForm from "../form/edit/EditTaskForm";
import Task from "../../../../model/task/Task";

interface IComponentProps {
	/**
	 * On successful created task callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Task to edit
	 */
	task: Task;
}

export default class EditTaskModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onCancel} title={"Edit Task"} fixedWidth>
				<EditTaskForm onSuccess={this.props.onSuccess} onCancel={this.props.onCancel} task={this.props.task}/>
			</Modal>
		);
	}
}
